import type { SerializedError } from '@reduxjs/toolkit';

export interface RequestState<Data> {
  data?: Data;
  status: 'idle' | 'pending' | 'fulfilled' | 'rejected';
  requestId?: string;
  error?: SerializedError;
  updatedAt: number;
  revision: number;
}

export const emptyRequest: RequestState<never> = {
  status: 'idle',
  updatedAt: 0,
  revision: 0,
};

export function requestKey(value: unknown): string {
  return JSON.stringify(value, (_key, item: unknown) => {
    if (item && typeof item === 'object' && !Array.isArray(item) && Object.getPrototypeOf(item) === Object.prototype) {
      return Object.fromEntries(Object.entries(item).sort(([left], [right]) => left.localeCompare(right)));
    }
    return item;
  });
}